// extracted by mini-css-extract-plugin
module.exports = {"overflow-hidden-container":"home_overflow-hidden-container__3l__F"};